module.exports = __webpack_public_path__ + "img/icon-list.94cb4a9e.png";